export default __webpack_public_path__ + "static/media/about_banner_bg.3dd16012.jpg";